/*==================================
=             PAGINATION           =
==================================*/
Vue.component('pagination', {
    template: '<div><slot></slot></div>',
    data: function() {
        return {
            current_page: 1,
            all_page: 1,
            current_items: []
        }
    },
    props: ['data', 'items_per_page'],
    created: function() {
        this.init();
    },
    methods: {
        init: function() {
            console.log("init");
            this.items_per_page = 3;
            this.all_page = Math.floor(this.data.length / this.items_per_page);

            var start = parseInt((this.current_page - 1) * this.items_per_page),
                end = parseInt(this.current_page * this.items_per_page);

            this.current_items = this.data.slice(start, end);
        }
    }
});